import { SlideLoveCover } from './SlideLoveCover'
import { Slide01Title } from './Slide01Title'
import { SlideLifecycleTail } from './SlideLifecycleTail'
import { SlideFormatByPhase } from './SlideFormatByPhase'
import { SlideValueCalculator } from './SlideValueCalculator'
import { SlideAgencyOfRecord } from './SlideAgencyOfRecord'
import { SlideSnakDefinition } from './SlideSnakDefinition'
import { SlideOperatingScale } from './SlideOperatingScale'
import { Slide02ExecSummary } from './Slide02ExecSummary'
import { Slide03Background } from './Slide03Background'
import { SlideMasterSnaks } from './SlideMasterSnaks'
import { SlideGovernanceView } from './SlideGovernanceView'
import { SlideCustomerJourneyExamples } from './SlideCustomerJourneyExamples'
import { SlideCampaignCostCalculator } from './SlideCampaignCostCalculator'

export const slides = [
  SlideLoveCover,
  Slide01Title,
  SlideLifecycleTail,
  SlideFormatByPhase,
  SlideValueCalculator,
  SlideAgencyOfRecord,
  SlideSnakDefinition,
  SlideOperatingScale,
  Slide02ExecSummary,
  Slide03Background,
  SlideMasterSnaks,
  SlideGovernanceView,
  SlideCustomerJourneyExamples,
  SlideCampaignCostCalculator,
]

export const slideTitles: { section: string; title: string }[] = [
  { section: 'Cover', title: 'All You Need Is Love' },
  { section: '02', title: 'Brand Campaign Strategy' },
  { section: '03', title: 'Three Priorities Across the Product Lifecycle' },
  { section: '04', title: 'As Familiarity Grows, Format Shortens' },
  { section: '05', title: 'The Value of a 1% Improvement' },
  { section: '06', title: 'Snak Agency of Record' },
  { section: '07', title: 'HCPs Don’t Lack Content. They Lack Time.' },
  { section: '08', title: 'Built for Continued Campaigns' },
  { section: '09', title: 'From Attention to Insight' },
  { section: '10', title: 'More Channels to Share' },
  { section: '11', title: 'Suggested Further Master Snaks' },
  { section: '12', title: 'One Governance View' },
  { section: '13', title: 'Snaks Throughout the Customer Journey' },
  { section: '14', title: 'Interactive Campaign Cost Calculator' },
]
